import { render, staticRenderFns } from "./RegionComponent.vue?vue&type=template&id=5d0b6e3e&scoped=true"
import script from "./RegionComponent.vue?vue&type=script&lang=js"
export * from "./RegionComponent.vue?vue&type=script&lang=js"
import style0 from "./RegionComponent.vue?vue&type=style&index=0&id=5d0b6e3e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0b6e3e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d0b6e3e')) {
      api.createRecord('5d0b6e3e', component.options)
    } else {
      api.reload('5d0b6e3e', component.options)
    }
    module.hot.accept("./RegionComponent.vue?vue&type=template&id=5d0b6e3e&scoped=true", function () {
      api.rerender('5d0b6e3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/region/RegionComponent.vue"
export default component.exports